import type { Slicer } from '@swf/core/store';

import type { SportsMyBetsState } from './types';

export const selectors = (slice: Slicer<SportsMyBetsState>) => ({
  showLoader: () => slice((state) => state.showLoader),
  isErroneous: () => slice((state) => state.isErroneous),
  bets: () => slice((state) => state.bets),
  cashedOut: () => slice((state) => state.cashedOut),
  moreAvailable: () => slice((state) => state.moreAvailable),
  cashOutQuotes: () => slice((state) => state.cashOutQuotes),
  cashOutBets: () => slice((slice) => slice.cashOutBets),
  pollingInterval: () => slice((slice) => slice.pollingInterval),
  isLoadingMoreBets: () => slice((slice) => slice.isLoadingMoreBets),
  selectedLiveOption: () => slice((slice) => slice.selectedLiveOption)
});
